import { readonlyArray } from 'fp-ts';

export const sum: (input: readonly number[]) => number = readonlyArray.reduce(
  0,
  (a: number, b: number) => a + b,
);
